'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const navItems = [
  { label: 'Home', href: '/' },
  { label: 'World', href: '/world' },
  { label: 'Politics', href: '/topic/politics' },
  { label: 'Business', href: '/topic/business' },
  { label: 'Technology', href: '/topic/technology' },
  { label: 'Climate', href: '/topic/climate' },
  { label: 'Opinion', href: '/opinion' },
  { label: 'Culture', href: '/topic/culture' },
  { label: 'Sport', href: '/topic/sport' },
  { label: 'Video', href: '/video' },
  { label: 'Live', href: '/live', isLive: true },
];

export default function PrimaryNav() {
  const pathname = usePathname();

  return (
    <nav className="sticky top-14 z-[140] bg-white border-b border-[#D4D4D4] h-11" aria-label="Primary navigation">
      <div className="max-w-[1400px] mx-auto px-5 h-full flex items-center overflow-x-auto scrollbar-none">
        {navItems.map((item) => {
          const isActive =
            (item.href === '/' && pathname === '/') ||
            (item.href !== '/' && pathname.startsWith(item.href) && pathname !== '/') ||
            (item.label === 'Live' && pathname === '/live') ||
            (item.label === 'Video' && pathname === '/video') ||
            (item.label === 'Opinion' && pathname === '/opinion');

          return (
            <Link
              key={item.label}
              href={item.href}
              className={`flex items-center gap-1.5 shrink-0 px-3.5 h-full font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[13px] tracking-[0.03em] border-b-[3px] -mb-px transition-all duration-150 ${
                isActive
                  ? 'border-[#C8102E] text-[#C8102E]'
                  : 'border-transparent text-[#2D2D2D] hover:border-[#D4D4D4] hover:text-[#0D0D0D]'
              }`}
            >
              {item.isLive && (
                <span className="w-[7px] h-[7px] bg-[#C8102E] circle-avatar animate-live-pulse shrink-0" />
              )}
              {item.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
